import { useEffect } from "react";
import PublicNav from "../layout/PublicNav";
import PublicFooter from "../layout/PublicFooter";

export default function PublicLayout({ children, title }) {
  useEffect(() => {
    if (title) {
      document.title = `${title} · Kinntegra`;
    } else {
      document.title = "Kinntegra · Beyond Portfolio Reporting";
    }
  }, [title]);

  return (
    <div className="bg-[#07111F] min-h-screen text-white">
      <PublicNav />
      <main
        style={{
          paddingTop:
            "max(5rem, calc(4rem + env(safe-area-inset-top)))",
        }}
      >
        {children}
      </main>
      <PublicFooter />
    </div>
  );
}
